import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { extractMargins } from '../../../util/spacing.js';
import { Box } from '../../Box/Box.js';
import { extractFlexItemProps } from '../../../types/Props.js';
import { useLoadingContainer } from './useLoadingContainer.js';

var _excluded = ["loadedContent", "loadingContent"];
var Container = Box;
var LoadingContentContainer = Box;
var LoadedContentContainer = Box;
var LoadingContainer = function LoadingContainer(_ref) {
  var loadedContent = _ref.loadedContent,
    loadingContent = _ref.loadingContent,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _extractMargins = extractMargins(rest),
    margins = _extractMargins.margins,
    propsWithoutMargins = _extractMargins.rest;
  var _extractFlexItemProps = extractFlexItemProps(propsWithoutMargins),
    flexItemProps = _extractFlexItemProps.flexItemProps,
    propsWithoutMarginsAndFlexItem = _extractFlexItemProps.rest;
  var _useLoadingContainer = useLoadingContainer(propsWithoutMarginsAndFlexItem),
    loadingProps = _useLoadingContainer.loadingProps,
    shouldRenderLoading = _useLoadingContainer.shouldRenderLoading,
    loadedProps = _useLoadingContainer.loadedProps,
    shouldRenderLoaded = _useLoadingContainer.shouldRenderLoaded;
  return /*#__PURE__*/React.createElement(Container, _extends({
    display: "flex",
    position: "relative"
  }, margins, flexItemProps), shouldRenderLoading && /*#__PURE__*/React.createElement(LoadingContentContainer, loadingProps, loadingContent), shouldRenderLoaded && /*#__PURE__*/React.createElement(LoadedContentContainer, _extends({
    position: shouldRenderLoading ? 'absolute' : 'static'
  }, loadedProps), loadedContent));
};
var LoadingContainerMemoized = /*#__PURE__*/React.memo(LoadingContainer);

export { LoadingContainer as BaseLoadingContainer, LoadingContainerMemoized as LoadingContainer };
//# sourceMappingURL=LoadingContainer.js.map
